interface ProgressBarProps {
  value: number
  showLabel?: boolean
  size?: 'sm' | 'md'
  color?: 'blue' | 'green' | 'amber' | 'red'
}

export function ProgressBar({ value, showLabel = true, size = 'md', color }: ProgressBarProps) {
  const clamped = Math.min(100, Math.max(0, value))

  let barColor = 'var(--accent-blue)'
  if (color) {
    const colorMap: Record<string, string> = {
      blue: 'var(--accent-blue)',
      green: 'var(--accent-green)',
      amber: 'var(--accent-amber)',
      red: 'var(--accent-red)',
    }
    barColor = colorMap[color] || barColor
  } else {
    if (clamped >= 80) barColor = 'var(--accent-green)'
    else if (clamped >= 50) barColor = 'var(--accent-blue)'
    else if (clamped >= 25) barColor = 'var(--accent-amber)'
    else barColor = 'var(--accent-red)'
  }

  const height = size === 'sm' ? '6px' : '10px'

  return (
    <div className="progress-bar-container">
      <div className="progress-bar-track" style={{ height }}>
        <div
          className="progress-bar-fill"
          style={{
            width: `${clamped}%`,
            backgroundColor: barColor,
            height: '100%',
            borderRadius: 'var(--radius-full)',
            transition: 'width 0.5s ease',
          }}
        />
      </div>
      {showLabel && (
        <span className="progress-bar-label">{Math.round(clamped)}%</span>
      )}
    </div>
  )
}
